import { SupporterType } from "@shared/lib/database/enum.types";
import { defineStore, storeToRefs } from "pinia";
import { computed } from "vue";
import useAuthStore from "./useAuthStore";

export default defineStore("MembershipStore", () => {
  const {
    currentPlayer,
    session,
  } = storeToRefs(useAuthStore());

  const supporterType = computed(() => currentPlayer.value?.supporter_type as SupporterType | undefined);

  async function fetchCheckoutUrlForSupporterType (supporterType: SupporterType) {
    const response = await fetch("/api/stripe/checkout-session", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${session.value!.access_token}`,
      },
      body: JSON.stringify({
        supporter_type: supporterType,
      }),
    });

    const data: {
      url?: string,
      error?: {
        message: string,
      },
    } = await response.json();

    return data;
  }

  async function fetchCustomerPortalUrl () {
    const response = await fetch("/api/stripe/customer-portal-session", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${session.value!.access_token}`,
      },
    });

    const data: {
      url?: string,
      error?: {
        message: string,
      },
    } = await response.json();

    return data;
  }

  return {
    supporterType,
    fetchCheckoutUrlForSupporterType,
    fetchCustomerPortalUrl,
  };
});
